module.exports = __webpack_public_path__ + "assets/img/tx113_2.a1e26cfc.jpg";